import { useCallback, type ReactNode } from "react";
import { appPaths } from "../../shared/routing/appPaths";
import { useWorkspace } from "../../shell/workspace";
import { IssueReportContext, type OpenIssueReport } from "./issueReportContext";

/**
 * The one way to "Report a problem" in the working app (F13). The help menu opens it, and so
 * does an error's reference, which arrives filled in. The report opens beside the page it is
 * about, through the workspace (WA-10), not in a modal that blocks the app (F34).
 */
export default function IssueReportProvider({ children }: { children: ReactNode }) {
  const workspace = useWorkspace();
  const open = useCallback<OpenIssueReport>(
    (prefill = {}) => { workspace.open(appPaths.issueReport(prefill.reference ?? null), { placement: "beside" }); },
    [workspace],
  );
  return <IssueReportContext.Provider value={open}>{children}</IssueReportContext.Provider>;
}
